"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnnualHomeValuableItemsWidget = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var services_1 = require("@falcon/services");
var uuid_1 = require("uuid");
var AnnualHomeSpecifiedItemInfo_1 = require("./AnnualHomeSpecifiedItemInfo");
var SpecifiedItemsInfoModal_1 = require("./SpecifiedItemsInfoModal");
var journey_services_1 = require("@athena-portal/journey-services");
var core_1 = require("@athena-portal/core");
var Types_1 = require("../../../../Types");
var ConfirmModal_1 = require("../../../../components/modals/ConfirmModal");
var AnnualHomeValuableItemModal_1 = require("./AnnualHomeValuableItemModal");
var commonFunctions_1 = require("../../../../commonFunctions");
var OptionalExtrasQuestionWidgetBase_1 = require("../../common/OptionalExtrasQuestionWidgetBase");
var journey_model_1 = require("@athena-portal/journey-model");
var AnnualHomeValuableItemsWidget = /** @class */ (function (_super) {
    __extends(AnnualHomeValuableItemsWidget, _super);
    function AnnualHomeValuableItemsWidget(props) {
        var _a;
        var _this = _super.call(this, props) || this;
        _this.handleOnChangeEvent = function () {
            if (_this.props.interaction.uistate.annualHomeAddonsState.valuableItems == null) {
                journey_services_1.ObjectManipulator.setField("uistate.optionalExtraPreviouslyEmptyNowUnselected", _this.props.interaction, true);
            }
            journey_services_1.ObjectManipulator.setField("uistate.annualHomeAddonsState.valuableItems", _this.props.interaction, false);
            _this.validateInternal("annualHomeValuableItems", false);
            _this.executeEvent("change");
        };
        _this.state = {
            isInfoModalOpen: false,
            isAddItemModalOpen: false,
            isRemovalModalOpen: false,
        };
        _this.toggleInfoModal = _this.toggleInfoModal.bind(_this);
        _this.toggleAddItemModal = _this.toggleAddItemModal.bind(_this);
        _this.toggleRemovalModal = _this.toggleRemovalModal.bind(_this);
        _this.removeItemEvent = _this.removeItemEvent.bind(_this);
        _this.addOrEditItem = _this.addOrEditItem.bind(_this);
        _this.editItem = _this.editItem.bind(_this);
        _this.removeItem = _this.removeItem.bind(_this);
        var addonsState = (_a = _this.props.interaction.uistate) === null || _a === void 0 ? void 0 : _a.annualHomeAddonsState;
        if (_this.getSetting("resetUnselectedAddons", false) && addonsState && !addonsState.valuableItems) {
            addonsState.valuableItems = null;
        }
        return _this;
    }
    AnnualHomeValuableItemsWidget.prototype.render = function () {
        var _a, _b, _c;
        var origValuableItems = (_a = this.props.interaction.valuableItems) !== null && _a !== void 0 ? _a : [];
        var valuableItems = origValuableItems
            .filter(function (item) { return item.added && item.flowValuable; });
        var hasValuableItems = valuableItems && valuableItems.length > 0;
        var backgroundClass;
        var widgetIcon = (0, jsx_runtime_1.jsx)("img", { className: "fixed-addon-icon flex-start", src: "/".concat(services_1.resourcesHelper.THEME, "/img/specified-items-quote-icon.png"), alt: "addon icon" });
        var wording;
        if (hasValuableItems) {
            backgroundClass = "fixed-addon-background-selected";
            wording = (0, jsx_runtime_1.jsxs)("p", { className: "mt-0 mb-0", children: ["Cover valuable item(s) worth more than ", (0, jsx_runtime_1.jsx)("span", { className: "font-weight-700", children: "\u00A32,000" }), " each"] });
        }
        else {
            backgroundClass = "fixed-addon-background";
            wording = (0, jsx_runtime_1.jsxs)("p", { className: "mt-0 mb-0", children: ["Cover valuable item(s) worth more than ", (0, jsx_runtime_1.jsx)("span", { className: "font-weight-700", children: "\u00A32,000" }), " each in and out of your home"] });
        }
        var validationErrors = (0, commonFunctions_1.getValidationErrors)(this.props, "annualHomeValuableItems");
        var hasValidationErrors = ((_b = validationErrors === null || validationErrors === void 0 ? void 0 : validationErrors.length) !== null && _b !== void 0 ? _b : 0) > 0;
        return ((0, jsx_runtime_1.jsx)("div", { id: "annualHomeValuableItems", className: "".concat(backgroundClass, " quote row mt-2 pb-0 ").concat(hasValidationErrors ? "is-invalid" : ""), children: (0, jsx_runtime_1.jsxs)("div", { className: "col p-0 fixed-addon-item", children: [widgetIcon, (0, jsx_runtime_1.jsxs)("div", { className: "fixed-addon-content", children: [(0, jsx_runtime_1.jsxs)("div", { className: "heading-info", children: [(0, jsx_runtime_1.jsx)("p", { className: "font-weight-bold mb-0 heading", children: "Specified items" }), (0, jsx_runtime_1.jsx)("button", { className: "fixed-addon-info cursor-pointer info-button", onClick: this.toggleInfoModal })] }), wording, this.renderAddedItems(valuableItems)] }), hasValidationErrors &&
                        (0, jsx_runtime_1.jsx)("div", { className: "invalid-feedback d-block", children: (_c = validationErrors[0]) === null || _c === void 0 ? void 0 : _c.errorMessage }), (0, jsx_runtime_1.jsxs)("div", { className: "fixed-addon-buttons", children: [!this.itemLimitReached() && this.renderAddLink(hasValuableItems), (0, jsx_runtime_1.jsx)(SpecifiedItemsInfoModal_1.default, { closeModal: this.toggleInfoModal, isOpen: this.state.isInfoModalOpen }), this.renderAddItemModal(), this.renderItemRemovalModal()] })] }) }));
    };
    AnnualHomeValuableItemsWidget.prototype.renderAddedItems = function (valuableItems) {
        return ((0, jsx_runtime_1.jsx)(AnnualHomeSpecifiedItemInfo_1.default, { items: valuableItems, editItem: this.editItem, removeItem: this.removeItemEvent }));
    };
    AnnualHomeValuableItemsWidget.prototype.renderAddLink = function (hasValuableItems) {
        var _a, _b;
        var noThanksSelected = ((_b = (_a = this.props.interaction.uistate) === null || _a === void 0 ? void 0 : _a.annualHomeAddonsState) === null || _b === void 0 ? void 0 : _b.valuableItems) === false;
        return ((0, jsx_runtime_1.jsxs)("div", { className: "optional-extra-btn-container", children: [(0, jsx_runtime_1.jsx)("button", { onClick: this.toggleAddItemModal, className: "".concat(hasValuableItems ? "optional-extra-btn-added-item" : "optional-extra-btn-no-items"), children: "Add item" }), !hasValuableItems && (0, jsx_runtime_1.jsx)("button", { onClick: this.handleOnChangeEvent, className: noThanksSelected ? "optional-extra-btn" : "optional-extra-btn-no-items", children: noThanksSelected ? "Not added" : "No, thanks" })] }));
    };
    AnnualHomeValuableItemsWidget.prototype.renderAddItemModal = function () {
        var item;
        var title;
        var buttonText;
        if (this.state.editItem) {
            item = this.state.editItem;
            title = "Edit item";
            buttonText = "Confirm Changes";
        }
        else {
            item = new services_1.AnnualHomeValuableItem();
            item.valuableItemId = (0, uuid_1.v4)();
            title = "Add item";
            buttonText = "Add item";
        }
        return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: this.state.isAddItemModalOpen && (0, jsx_runtime_1.jsx)(AnnualHomeValuableItemModal_1.default, { title: title, buttonText: buttonText, item: item, interaction: this.props.interaction, closeModal: this.toggleAddItemModal, onConfirm: this.addOrEditItem }) }));
    };
    AnnualHomeValuableItemsWidget.prototype.renderItemRemovalModal = function () {
        return ((0, jsx_runtime_1.jsx)(ConfirmModal_1.default, { show: this.state.isRemovalModalOpen, onHide: this.toggleRemovalModal, onConfirm: this.removeItem, confirmButtonText: "Yes, please", children: (0, jsx_runtime_1.jsx)("div", { className: "fs-20 font-weight-medium font-family-display", children: "Are you sure you want to remove this item?" }) }));
    };
    AnnualHomeValuableItemsWidget.prototype.toggleInfoModal = function () {
        this.setState({
            isInfoModalOpen: !this.state.isInfoModalOpen
        });
    };
    AnnualHomeValuableItemsWidget.prototype.toggleAddItemModal = function () {
        var newValue = !this.state.isAddItemModalOpen;
        this.setState({
            isAddItemModalOpen: newValue
        });
        if (!newValue) {
            this.setState({
                editItem: undefined
            });
        }
    };
    AnnualHomeValuableItemsWidget.prototype.toggleRemovalModal = function () {
        this.setState({
            isRemovalModalOpen: !this.state.isRemovalModalOpen
        });
    };
    AnnualHomeValuableItemsWidget.prototype.removeItemEvent = function (item) {
        this.setState({
            removeItem: item
        });
        this.toggleRemovalModal();
    };
    AnnualHomeValuableItemsWidget.prototype.addOrEditItem = function (item) {
        var items = this.props.interaction.valuableItems ? this.props.interaction.valuableItems.slice() : [];
        if ((items === null || items === void 0 ? void 0 : items.filter(function (innerItem) { return innerItem.valuableItemId === item.valuableItemId; }).length) === 0) {
            items.push(item);
        }
        else {
            items = items === null || items === void 0 ? void 0 : items.map(function (innerItem) {
                return innerItem.valuableItemId === item.valuableItemId ? item : innerItem;
            });
        }
        journey_services_1.ObjectManipulator.setFieldWithTrackChanges("valuableItems", items, {
            interaction: this.props.interaction,
            initialInteraction: this.props.initialInteraction,
        });
        journey_services_1.ObjectManipulator.setField("uistate.annualHomeAddonsState.valuableItems", this.props.interaction, true);
        this.executeEvent("change");
        this.changelogRecorder.recordPage("change", this.props, "valuableItems");
        this.setState({
            isAddItemModalOpen: false,
            editItem: undefined
        });
    };
    AnnualHomeValuableItemsWidget.prototype.editItem = function (item) {
        this.setState({
            editItem: item
        });
        this.toggleAddItemModal();
    };
    AnnualHomeValuableItemsWidget.prototype.removeItem = function () {
        if (this.state.removeItem) {
            var item = this.state.removeItem;
            var items = this.props.interaction.valuableItems ? __spreadArray([], this.props.interaction.valuableItems, true) : [];
            var index = items.map(function (i) { return i.valuableItemId; }).indexOf(item.valuableItemId);
            items.splice(index, 1);
            journey_services_1.ObjectManipulator.setField("uistate.annualHomeAddonsState.valuableItems", this.props.interaction, items.length > 0);
            journey_services_1.ObjectManipulator.setFieldWithTrackChanges("valuableItems", items, {
                interaction: this.props.interaction,
                initialInteraction: this.props.initialInteraction,
            });
            this.executeEvent("change");
            this.changelogRecorder.recordPage("change", this.props, "valuableItems");
            this.toggleRemovalModal();
            this.setState({
                removeItem: undefined
            });
        }
    };
    AnnualHomeValuableItemsWidget.prototype.itemLimitReached = function () {
        return this.props.interaction.valuableItems && this.props.interaction.valuableItems.length >= 16;
    };
    __decorate([
        (0, core_1.lazyInject)(Types_1.Types.ChangelogRecorder),
        __metadata("design:type", Object)
    ], AnnualHomeValuableItemsWidget.prototype, "changelogRecorder", void 0);
    AnnualHomeValuableItemsWidget = __decorate([
        (0, journey_model_1.settings)([
            { name: "resetUnselectedAddons", type: journey_model_1.TypeDescriptions.Boolean },
        ]),
        __metadata("design:paramtypes", [Object])
    ], AnnualHomeValuableItemsWidget);
    return AnnualHomeValuableItemsWidget;
}(OptionalExtrasQuestionWidgetBase_1.OptionalExtrasQuestionWidgetBase));
exports.AnnualHomeValuableItemsWidget = AnnualHomeValuableItemsWidget;
//# sourceMappingURL=AnnualHomeValuableItemsWidget.js.map